export default function Menu({ userType }) {
  return (
    <div className="menuContainer primary white">
      {userType === 1 && <div className="menuExchange">EXCHANGE</div>}
      {(userType === 1 || userType === 2) && (
        <div className="menuExchange">SUPER</div>
      )}
      {(userType === 1 || userType === 2 || userType === 3) && (
        <div className="menuExchange">MASTER</div>
      )}
      <div className="menuExchange">USER</div>
      <div className="menuExchange">SYMBOL</div>
      <div className="menuExpiry">EXPIRY</div>
      <div className="menuBuyPrice">BUY/SELL</div>
      <div className="menuBuyQty">QTY</div>
      <div className="menuSellPrice">RATE</div>
      <div className="menuSellPrice">LIVE RATE</div>
      <div className="menuClose">PROFIT/LOSS</div>
      <div className="menuLtt">LTT/LUT</div>
    </div>
  );
}
